const monitorRouterPaths = {
  root: '/monitor',
  servers: '/monitor/servers',
  logs: '/monitor/logs',
  tasks: '/monitor/logs/tasks',
  taskGraphLogs: '/monitor/logs/taskgraphs',
};

export default monitorRouterPaths;
